import { IOption } from '../../../models/IOption';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ff-checkboxes',
  templateUrl: './checkboxes.component.html',
  styleUrls: ['./checkboxes.component.scss']
})
export class CheckboxesComponent {

  /**
   * Options to display as radio buttons
   * Use the IOption interface: { value: string; text: string; selected?: boolean; }
   * * @internal
  */
  @Input() options: IOption[]

  /**
   * Return the options updated each time the user check an option.
   * * @internal
  */
  @Output() updatedValues = new EventEmitter<IOption[]>();

  constructor() { }

  onChange = (option: IOption) => {
    option = {...option, selected: !option.selected};
    this.options = this.options.map(element => element.value === option.value
      ? {...element, selected: option.selected}
      : element);

      this.updateValues();
  }

  /**
   * Return the updated array to the parent component
  */
  private updateValues = (): void => {
    this.updatedValues.emit(this.options);
  }

}
